import { render, staticRenderFns } from "./BattChart.vue?vue&type=template&id=8284ca42&"
import script from "./BattChart.vue?vue&type=script&lang=js&"
export * from "./BattChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports